module.exports = __webpack_public_path__ + "img/Icon_Folder.28c2cf5d.svg";